import { Link } from "react-router-dom";

// Exact copy and route decisions locked in
// EXPERIA_Footer_Pages_Exact_Copy_for_Claude.docx — do not rewrite labels,
// identity text, disclaimer, or grouping without checking that source.
const FOOTER_LINKS = {
  Platform: [
    { label: "Explore", to: "/topics" }, // TODO: point to a real /explore page once it exists — spec says Explore must be its own destination, not an alias of Topics.
    { label: "Live", to: "/live" },
    { label: "Experts", to: "/experts" },
    { label: "Topics", to: "/topics" },
    { label: "Questions", to: "/questions" },
  ],
  Company: [
    { label: "About", to: "/about" },
    { label: "How It Works", to: "/how-it-works" },
    { label: "Become an Expert", to: "/become-an-expert" },
    { label: "Contact", to: "/contact" },
  ],
  Support: [
    { label: "Help Center", to: "/help" },
    { label: "Safety", to: "/safety" },
    { label: "Community Guidelines", to: "/community-guidelines" },
  ],
  Legal: [
    { label: "Privacy", to: "/privacy" },
    { label: "Terms", to: "/terms" },
    { label: "Reservation & Refund Policy", to: "/reservation-policy" },
    { label: "Expert Guidelines", to: "/expert-guidelines" },
  ],
};

export default function SiteFooter() {
  return (
    <footer className="border-t border-white/[0.08] bg-black px-6 py-10 lg:px-10 lg:py-14">
      <div className="mx-auto max-w-[1200px]">
        <div className="lg:flex lg:items-start lg:justify-between lg:gap-16">
          {/* Identity — the strongest element in the footer */}
          <div className="lg:w-[220px] lg:shrink-0">
            <Link
              to="/"
              className="font-serif text-xl tracking-[0.2em] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300"
            >
              EXP<span className="text-violet-300">É</span>RIA
            </Link>
            <p className="mt-2.5 max-w-[220px] text-xs leading-relaxed text-white/45">
              Real people. Real experience. Real access.
            </p>
          </div>

          {/* Four categories — a true 2-column grid on mobile, not a long single list */}
          <div className="mt-9 grid grid-cols-2 gap-x-6 gap-y-8 lg:mt-0 lg:grid-cols-4 lg:gap-x-10">
            {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
              <div key={heading}>
                <p className="font-accent text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-white/35">
                  {heading}
                </p>
                <ul className="mt-3.5 space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="font-accent text-sm text-white/60 transition hover:text-white focus-visible:outline-none focus-visible:text-white"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Quietest elements: disclaimer, then copyright */}
        <div className="mx-auto mt-10 max-w-[560px] border-t border-white/[0.08] pt-6 text-center">
          <p className="font-accent text-[0.7rem] leading-relaxed text-white/30">
            Conversations on EXPÉRIA are educational and do not replace professional medical, legal, financial, or other licensed professional advice.
          </p>
          <p className="mt-3 font-accent text-[0.7rem] text-white/25">
            ©️ {new Date().getFullYear()} EXPÉRIA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
